import type { ReactElement } from 'react';
import React from 'react';
import { ApolloProvider } from 'react-apollo';

import type {
	ExtensionParams,
	ExtensionHandler,
} from '@atlaskit/editor-common/extensions/extension-handler';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { SessionData } from '@confluence/session-data/entry-points/SessionData.ts';
import { SessionDataContext } from '@confluence/session-data/entry-points/SessionDataContext.ts';
import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient.ts';

// type ExtensionHandler<T> = (ext: ExtensionParams<T>, doc: Object)
export const createMacroExtensionHandler =
	(extensionHandler: ExtensionHandler<any>) =>
	(extension: ExtensionParams<any>, ...args: any[]): ReactElement => (
		<ErrorBoundary attribution={Attribution.PAGE_EXTENSIONS}>
			<ApolloProvider client={getApolloClient()}>
				<SessionData>
					{(sessionData) => (
						<SessionDataContext.Provider value={sessionData}>
							{extensionHandler(extension, args)}
						</SessionDataContext.Provider>
					)}
				</SessionData>
			</ApolloProvider>
		</ErrorBoundary>
	);
